module.exports = __webpack_public_path__ + "img/domestic-2012-softpower.43727c80.jpg";